import React, { useState, useEffect, useRef } from "react"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"

import Breadcrumbs from "components/Common/Breadcrumb"
import SendSMSModal from "./SendSMSModal"

import { sendSms } from "helpers/backend_helper"
import { showToast } from "utils/general"

import { useFormik } from "formik"
import * as Yup from "yup"

import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  TabPane,
  Button,
} from "reactstrap"
import { Tabs } from "antd"

const SMSMessaging = props => {
  const [activeTab] = useState("1")
  const [sendSMSModal, setSendSMSModal] = useState(false)
  const [sending, setSending] = useState(false)

  const abortRef = useRef(null)
  useEffect(() => {
    document.title = props.t("SMS Messaging") + " | Suvanto Care"
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Formik validation
  const smsValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      recipient: "",
      message:
        "\n\n\n--\nViestiin ei voi vastata.\nVastaukset sähköpostilla osoitteeseen tuki@suvantocare.fi\nSuvanto Care Tuki",
    },
    validationSchema: Yup.object({
      message: Yup.string().required(props.t("Required field")),
      recipient: Yup.string().required(props.t("Required field")),
    }),
    onSubmit: values => {
      if (!sending) {
        setSending(true)
        sendSms(
          abortRef.current,
          values.message,
          values.recipient,
          "+358509020154",
          null,
          null
        )
          .then(response => {
            console.log("Send response: ", response)
            showToast(props.t("Message sent"), "success")
            // setDateRange([dateRange[0], dayjs()])
          })
          .catch(e => {
            showToast(props.t("Error"), "error")
            console.log(e)
          })
          .finally(() => {
            setSending(false)
            setSendSMSModal(false)
          })
      }
    },
  })

  // Tab 1, send message
  const sendMessageJSX = (
    <TabPane tabId={1} className="">
      <Row>
        <div className="email-bulletins-col-1">
          <Button
            color="success"
            style={{ width: "100%" }}
            className="mb-3 mt-0 py-2"
            onClick={() => {
              setSendSMSModal(true)
            }}
            disabled={activeTab == 3}
          >
            <i className="mdi mdi-pencil-plus font-size-14 me-2"></i>
            {props.t("New") + " " + props.t("SMS message")}
          </Button>
        </div>
      </Row>
    </TabPane>
  )

  const itemsTabs = [
    {
      key: "1",
      label: props.t("Messages"),
      children: sendMessageJSX,
    },
  ]

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={props.t("SMS Messaging")} />
          <Row>
            <Col lg={12} xxl={12}>
              <Card>
                <CardBody className="pt-1">
                  <Tabs defaultActiveKey="1" items={itemsTabs} />
                </CardBody>
              </Card>
            </Col>
            {
              <SendSMSModal
                sendSMSModal={sendSMSModal}
                setSendSMSModal={setSendSMSModal}
                smsValidation={smsValidation}
              />
            }
          </Row>
        </Container>
      </div>
    </>
  )
}

SMSMessaging.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(SMSMessaging)
